// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"content_wrapper__oirjo","section":"content_section__G7ZMQ","first-section":"content_first-section__olVcx"};